export const API_URL = process.env.REACT_APP_API_URL || 'https://woundtest.pythonanywhere.com';
export const API_KEY = process.env.REACT_APP_API_KEY || '26fb246a-64b9-4d96-895d-c20f4edcfa68';
